import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { GeoreferenceParentType } from '~/apollo/generated/v4/graphql';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { GeoreferenceManagerV4 } from '~/components/upload/georeference-v4/georeference-manager';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

export const UPDATE_VOM_GEOREFERENCES_PAGE = graphql(`
  query UpdateVomGeoreferencesPage($id: ID!) {
    virtualOutcropModelGet(id: $id) {
      id
      georeferences {
        ...georeferenceParts
      }
    }
  }
`);

export default function UpdateVomGeoreferencesPage() {
  return (
    <ApolloProviderV4>
      <UpdateVomGeoreferencesPageInner />
    </ApolloProviderV4>
  );
}

function UpdateVomGeoreferencesPageInner() {
  const vomId = useRouteParam('vomId', parseInt);

  const { data, loading } = useQuery(UPDATE_VOM_GEOREFERENCES_PAGE, {
    variables: { id: vomId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: UPDATE_VOM_GEOREFERENCES_PAGE,
      variables: { id: vomId },
    },
  ]);

  const vom = data?.virtualOutcropModelGet;
  const georeferences = vom?.georeferences ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!vom) return <NotFound />;

  return (
    <GeoreferenceManagerV4
      georeferences={georeferences}
      parentType={GeoreferenceParentType.Vom}
      parentId={vomId}
      refetchQueries={refetchQueries}
    />
  );
}
